import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { getButtonsByStatus } from '@app/components/statusBar/actionButtons';
import StatusBar from '@app/components/statusBar/statusBar';
import { UserRolesRequest } from '@app/models/user_roles/UserRolesRequest';
import { Tooltip, Button, Tabs } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BaseCheckbox } from '@app/components/common/BaseCheckbox/BaseCheckbox';
import { ProductPricingTable } from '../ProductPricing/ProductPricingTable';

type ProductVarietiesFormProps = {
  type: 'edit' | 'create' | 'view';
  editable: boolean;
  id?: string;
  showEditIcon?: boolean;
  pageTitle: string;
};

const ProductVarietiesForm: React.FC<ProductVarietiesFormProps> = ({ editable = false, id, pageTitle, type }) => {
  const [form] = BaseButtonsForm.useForm();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const productId = id ? parseInt(id) : null;

  const handleSubmit = (values: UserRolesRequest) => {
    // if (editable) {
    //   const submissionData = {
    //     ...values,
    //   };

    //   if (type === 'create') {
    //     storeUserRole(submissionData)
    //       .then((res: any) => {
    //         setLoading(false);
    //         navigate(`/view-role/${res?.data?.id}`);
    //       })
    //       .catch((err: any) => {
    //         notificationController.error({ message: err.message });
    //         setLoading(false);
    //       });
    //   } else if (type === 'edit' && productId) {
    //     updateUserRole(productId, submissionData)
    //       .then(() => {
    //         setLoading(false);
    //         navigate(`/view-role/${id}`);
    //       })
    //       .catch((err: any) => {
    //         notificationController.error({ message: `${err.message}` });
    //         setLoading(false);
    //       });
    //   }
    // }
    console.log('Form Submitted');
  };

  return (
    <>
      <BaseRow gutter={[16, 16]}>
        <BaseCol span={24}>
          <StatusBar
            id={String(productId)}
            status={status}
            // buttons={getButtonsByStatus(status, form, handleSubmit, navigate)}
          />
        </BaseCol>
        <BaseCol span={24}>
          <BaseCard
            id="productVarietiesForm"
            title={pageTitle}
            padding="1.25rem"
            style={{ margin: '20px', marginTop: '0px', width: '98%' }}
            extra={
              type === 'view' && (
                <Tooltip title="Edit">
                  <Button type="ghost" onClick={() => navigate(`/edit-product`)}>
                    Edit
                  </Button>
                </Tooltip>
              )
            }
          >
            <BaseRow gutter={[16, 16]}>
              <BaseCol span={24}>
                <BaseButtonsForm
                  form={form}
                  labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
                  labelAlign="left"
                  labelWrap
                  layout="horizontal"
                  wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
                  size="small"
                  name="productVarietiesForm"
                  onFinish={handleSubmit}
                  isFieldsChanged={false}
                >
                  <BaseRow gutter={[16, 16]}>
                    <BaseCol xs={24} md={24} lg={12}>
                      <BaseButtonsForm.Item name="code" label="Item Code">
                        <BaseInput readOnly={true} />
                      </BaseButtonsForm.Item>
                    </BaseCol>

                    <BaseCol xs={24} md={24} lg={12}>
                      <BaseButtonsForm.Item label="Product" name="product_id">
                        <BaseSelect />
                      </BaseButtonsForm.Item>
                    </BaseCol>
                  </BaseRow>

                  <BaseRow gutter={[16, 16]}>
                    <BaseCol xs={24} md={24} lg={12}>
                      <BaseButtonsForm.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Name is required' }]}
                      >
                        <BaseInput readOnly={!editable} />
                      </BaseButtonsForm.Item>
                    </BaseCol>

                    <BaseCol xs={24} md={24} lg={12}>
                      {/* <BaseButtonsForm.Item label="Type" name="type">
                  <BaseSelect  />
                </BaseButtonsForm.Item> */}
                    </BaseCol>
                  </BaseRow>

                  <BaseRow gutter={[16, 16]}>
                    <BaseCol xs={24} md={24} lg={12}>
                      <BaseButtonsForm.Item label="Importable" name="importable">
                        <BaseCheckbox />
                      </BaseButtonsForm.Item>
                    </BaseCol>

                    <BaseCol xs={24} md={24} lg={12}>
                      <BaseButtonsForm.Item label="Exportable" name="exportable">
                        <BaseCheckbox />
                      </BaseButtonsForm.Item>
                    </BaseCol>

                    <BaseCol xs={24} md={24} lg={12}>
                      <BaseButtonsForm.Item label="Status" name="status">
                        <BaseSelect />
                      </BaseButtonsForm.Item>
                    </BaseCol>

                    <BaseCol xs={24} md={24} lg={12}>
                      <BaseButtonsForm.Item label="Description" name="description">
                        <BaseInput.TextArea readOnly={!editable} />
                      </BaseButtonsForm.Item>
                    </BaseCol>
                  </BaseRow>
                </BaseButtonsForm>
              </BaseCol>
              {type != 'create' && (
                <BaseCol span={24}>
                  <Tabs>
                    <Tabs.TabPane tab="Pricing" key="tab-1">
                      <ProductPricingTable
                        product_category_id={null}
                        product_id={null}
                        product_variety_id={productId}
                      />
                    </Tabs.TabPane>
                  </Tabs>
                </BaseCol>
              )}
            </BaseRow>
          </BaseCard>
        </BaseCol>
      </BaseRow>
    </>
  );
};

export default ProductVarietiesForm;
